// modules/invoice/mappers/mapTemplate.ts
import {
  InvoiceTemplateData,
  SupplierInformation,
  Signature,
  Footer,
  BankDetails,
} from "../types/invoiceTemplate";

export function mapTemplate(template: Record<string, any>): InvoiceTemplateData {
  const supplier = template.SupplierInformation ?? {};
  const signature = template.Signature ?? {};
  const footer = template.Footer ?? {};
  const bank = template["Bank Details"] ?? {};

  return {
    supplierInformation: {
      supplierName: supplier.SupplierName ?? "",
      addressLine1: supplier.AddressLIne1 ?? "",
      addressLine2: supplier.AddressLIne2 ?? "",
      addressLine3: supplier.AddressLIne3 ?? "",
      addressLine4: supplier.AddressLIne4 ?? "",
      pan: supplier.PAN ?? "",
      gstn: supplier.GSTN ?? "",
    } as SupplierInformation,

    signature: {
      generatedBy: signature["Generated By"] ?? "",
    } as Signature,

    footer: {
      registeredOffice: footer.RegisteredOffice ?? "",
      line1: footer.Line1 ?? "",
      line2: footer.Line2 ?? "",
      line3: footer.Line3 ?? "",
      line4: footer.Line4 ?? "",
    } as Footer,

    paymentMode: template["Payment Mode:"] ?? "",

    bankDetails: {
      accountName: bank.AccountName ?? "",
      accountNumber: bank["Account No:"] ?? "",
      ifscCode: bank["IFSC Code:"] ?? "",
      addressLine1: bank.AddressLIne1 ?? "",
      addressLine2: bank.AddressLIne2 ?? "",
      addressLine3: bank.AddressLIne3 ?? "",
      addressLine4: bank.AddressLIne4 ?? "",
    } as BankDetails,

    customSections: template.custom_sections ?? {},
  };
}
